<script setup lang="ts">
const { square = false, loading = false } = defineProps<{
  square?: boolean;
  loading?: boolean;
}>();
</script>

<template>
  <ion-button
    v-bind="$attrs"
    :shape="square ? undefined : 'round'"
    expand="block"
    size="large"
    class="base-button normal-case text-base"
    :class="{ square: square }"
  >
    <ion-spinner v-if="loading" name="crescent" />
    <slot v-else />
  </ion-button>
</template>

<style scoped lang="scss">
@import '@/scss/setup/_functions.scss';
.base-button {
  margin: 0;
  font-family: 'DM Sans-Bold';
  &.square {
    --border-radius: 0.5rem;
  }

  &.button-large {
    height: toRem(48px);
  }
}
</style>
